export default "__VITE_ASSET__BaoWj7dk__"